import { getApps, initializeApp, type FirebaseOptions } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

export const SUPER_ADMIN_EMAIL = "cornergayrimenkul001@gmail.com";

const config: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY?.trim(),
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN?.trim(),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID?.trim(),
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET?.trim(),
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID?.trim(),
  appId: import.meta.env.VITE_FIREBASE_APP_ID?.trim(),
};

const required = [config.apiKey, config.authDomain, config.projectId, config.appId];
const hasAnyConfiguration = Object.values(config).some(Boolean);
export const isFirebaseConfigured = required.every((value) =>
  Boolean(value && !/placeholder|your[-_]|example|xxxx/i.test(value)),
);
export const firebaseConfigurationError = hasAnyConfiguration && !isFirebaseConfigured
  ? "Firebase web yapılandırması eksik. Canlı yayın için proje ayarlarını tamamlayın."
  : null;

export const firebaseApp = isFirebaseConfigured
  ? getApps().find((app) => app.name === "corner-listings") ?? initializeApp(config, "corner-listings")
  : null;
export const firebaseAuth = firebaseApp ? getAuth(firebaseApp) : null;
export const firebaseDb = firebaseApp ? getFirestore(firebaseApp) : null;
export const firebaseStorage = firebaseApp && config.storageBucket ? getStorage(firebaseApp) : null;

